export class LinkData {

    public link: string;
    public label: string;
    public icon: string;

    constructor(linkData: any = {}) {
        this.link = linkData.link || '';
        this.label = linkData.label || '';
        this.icon = linkData.icon || '';
    }

    get type() {
        return 'linkData';
    }

}
